(() => {
  const money = (cents) => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);
    return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: window.Shopify?.currency?.active || 'TRY', maximumFractionDigits: 2 }).format(cents / 100);
  };
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const openCart = () => { drawer?.classList.add('is-open'); overlay?.classList.add('is-open'); document.body.classList.add('cart-open'); drawer?.setAttribute('aria-hidden', 'false'); };
  const closeCart = () => { drawer?.classList.remove('is-open'); overlay?.classList.remove('is-open'); document.body.classList.remove('cart-open'); drawer?.setAttribute('aria-hidden', 'true'); };

  document.querySelectorAll('[data-cart-open], .aa-cart-button, a[href="/cart"], .st-cart-link').forEach((button) => button.addEventListener('click', async (event) => {
    event.preventDefault();
    await refreshCart();
    openCart();
  }));
  document.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  overlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
  const mobileMenuButton = document.querySelector('[data-mobile-menu]');
  const mobileNav = document.querySelector('[data-nav]');
  mobileMenuButton?.addEventListener('click', () => {
    const open = mobileNav?.classList.toggle('is-open');
    mobileMenuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    mobileMenuButton.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
  });
  mobileNav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    mobileNav.classList.remove('is-open'); mobileMenuButton?.setAttribute('aria-expanded', 'false');
  }));

  const startCountdown = (clock) => {
    let seconds = Number(clock.dataset.minutes || 10) * 60;
    const render = () => {
      seconds = seconds <= 0 ? Number(clock.dataset.minutes || 10) * 60 : seconds - 1;
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      const boxes = clock.querySelectorAll('b');
      if (boxes.length === 3) { boxes[0].textContent = String(hours).padStart(2,'0'); boxes[1].textContent = String(minutes).padStart(2,'0'); boxes[2].textContent = String(secs).padStart(2,'0'); }
      else clock.textContent = `${String(minutes).padStart(2,'0')}:${String(secs).padStart(2,'0')}`;
    };
    render(); setInterval(render, 1000);
  };
  document.querySelectorAll('[data-countdown]').forEach(startCountdown);

  const randomBetween = (min, max) => Math.floor(Math.random() * (Math.max(min, max) - Math.min(min, max) + 1)) + Math.min(min, max);
  document.querySelectorAll('[data-live-widget]').forEach((widget) => {
    const number = widget.querySelector('[data-live-count]');
    const update = () => { number.textContent = randomBetween(Number(widget.dataset.min || 30), Number(widget.dataset.max || 60)); };
    update(); setInterval(update, 6500);
  });
  document.querySelectorAll('[data-stock-widget]').forEach((widget) => {
    const number = widget.querySelector('[data-stock-count]');
    const update = () => { if (number) number.textContent = randomBetween(Number(widget.dataset.min || 28), Number(widget.dataset.max || 38)); };
    update(); setInterval(update, 11500);
  });
  document.querySelectorAll('[data-proof-rotator]').forEach((rotator) => {
    const slides = [...rotator.querySelectorAll('.aa-proof-slide')];
    const favorite = randomBetween(Number(rotator.dataset.favoriteMin || 43), Number(rotator.dataset.favoriteMax || 58));
    const cartCount = randomBetween(Number(rotator.dataset.proofCartMin || 72), Number(rotator.dataset.proofCartMax || 94));
    const salesCount = randomBetween(Number(rotator.dataset.salesMin || 420), Number(rotator.dataset.salesMax || 520));
    const favoriteNode = rotator.querySelector('[data-favorite-count]');
    const cartNode = rotator.querySelector('[data-proof-cart-count]');
    const salesNode = rotator.querySelector('[data-sales-count]');
    if (favoriteNode) favoriteNode.textContent = `${(favorite / 10).toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} B`;
    if (cartNode) cartNode.textContent = cartCount;
    if (salesNode) salesNode.textContent = `${salesCount}+`;
    let active = 0;
    if (slides.length > 1) setInterval(() => {
      slides[active].classList.remove('is-current');
      active = (active + 1) % slides.length;
      slides[active].classList.add('is-current');
    }, 3400);
  });
  document.querySelectorAll('[data-cart-scarcity]').forEach((widget) => {
    const number = widget.querySelector('[data-cart-interest]');
    const update = () => { number.textContent = randomBetween(Number(widget.dataset.min || 50), Number(widget.dataset.max || 90)); };
    update(); setInterval(update, 7900);
  });
  document.querySelectorAll('.aa-live, .aa-cart-scarcity').forEach((widget, index) => {
    const pulse = () => {
      widget.classList.add('is-pulsing');
      setTimeout(() => widget.classList.remove('is-pulsing'), 900);
      setTimeout(pulse, randomBetween(6500, 12000) + (index * 700));
    };
    setTimeout(pulse, 1800 + (index * 1200));
  });

  document.querySelectorAll('[data-purchase-toast]').forEach((toast) => {
    let showTimer; let hideTimer; let stopped = false;
    const items = [...toast.querySelectorAll('[data-toast-items] > span')];
    const customer = toast.querySelector('[data-toast-customer]');
    const location = toast.querySelector('[data-toast-location]');
    const time = toast.querySelector('[data-toast-time]');
    const orders = toast.querySelector('[data-toast-orders]');
    try { stopped = sessionStorage.getItem('aaPurchaseToastClosed') === '1'; } catch (_) {}
    const schedule = (seconds) => { if (!stopped) showTimer = setTimeout(show, seconds * 1000); };
    const show = () => {
      if (stopped) return;
      const item = items.length ? items[randomBetween(0, items.length - 1)] : null;
      if (item) { customer.textContent = item.dataset.customer || 'Bir müşteri'; location.textContent = item.dataset.location || 'Türkiye'; }
      time.textContent = `${randomBetween(1, 9)} dk önce`;
      orders.textContent = randomBetween(Number(toast.dataset.orderMin || 20), Number(toast.dataset.orderMax || 40));
      toast.classList.add('is-visible');
      hideTimer = setTimeout(() => {
        toast.classList.remove('is-visible');
        schedule(randomBetween(Number(toast.dataset.repeatMin || 12), Number(toast.dataset.repeatMax || 24)));
      }, Number(toast.dataset.visible || 6) * 1000);
    };
    toast.querySelector('[data-toast-close]')?.addEventListener('click', () => {
      stopped = true; clearTimeout(showTimer); clearTimeout(hideTimer); toast.classList.remove('is-visible'); toast.classList.add('is-dismissed');
      try { sessionStorage.setItem('aaPurchaseToastClosed', '1'); } catch (_) {}
    });
    if (!stopped) schedule(Number(toast.dataset.delay || 4)); else toast.classList.add('is-dismissed');
  });

  document.querySelectorAll('[data-review-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-review-track]');
    const cards = [...track.querySelectorAll('article')];
    const dots = slider.parentElement.querySelector('[data-review-dots]');
    let timer; let paused = false;
    const step = () => (cards[0]?.getBoundingClientRect().width || 300) + 16;
    const activeIndex = () => Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / step())));
    const paintDots = () => dots?.querySelectorAll('i').forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex()));
    if (dots && cards.length) dots.innerHTML = cards.map((_, index) => `<i${index === 0 ? ' class="is-active"' : ''}></i>`).join('');
    const move = (direction) => {
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      if (direction > 0 && atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: step() * direction, behavior: 'smooth' });
    };
    slider.querySelector('[data-review-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-review-next]')?.addEventListener('click', () => move(1));
    track.addEventListener('scroll', () => requestAnimationFrame(paintDots), { passive: true });
    slider.addEventListener('mouseenter', () => { paused = true; });
    slider.addEventListener('mouseleave', () => { paused = false; });
    slider.addEventListener('focusin', () => { paused = true; });
    slider.addEventListener('focusout', () => { paused = false; });
    if (slider.dataset.autoplay === 'true' && cards.length > 1) timer = setInterval(() => { if (!paused) move(1); }, Number(slider.dataset.speed || 5) * 1000);
  });

  document.querySelectorAll('[data-scroll-top]').forEach((button) => button.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' })));

  async function refreshCart() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      const cart = await response.json();

      // --- GENERIC MULTI-UPSELL INTEGRITY GUARD ---
      const hasMainProduct = window.HD_UPSELL_GUARD
        ? window.HD_UPSELL_GUARD.hasMainProduct(cart.items)
        : Boolean(cart.items && cart.items.some((item) =>
            item.variant_id !== 48396151488748 &&
            item.variant_id !== 48396151816428 &&
            item.variant_id !== 54634982244718 &&
            item.variant_id !== 54642329616750 &&
            item.handle !== 'mini-buket' &&
            item.handle !== 'mini-buket-1'
          ));

      // Show/hide drawer upsell card based on whether a qualifying main product is in cart
      const upsellCard = document.querySelector('[data-cart-upsell]');
      if (upsellCard) {
        upsellCard.style.display = hasMainProduct ? 'flex' : 'none';
      }

      if (window.HD_UPSELL_GUARD) {
        const modified = await window.HD_UPSELL_GUARD.enforceCart(cart);
        if (modified) return refreshCart();

        // If main product is present, clean up any standalone duplicates of active upsell items
        if (hasMainProduct && cart.items) {
          const upsells = cart.items.filter(window.HD_UPSELL_GUARD.isUpsell);
          for (let i = 0; i < upsells.length; i++) {
            const target = window.HD_UPSELL_GUARD.getStandaloneTarget(upsells[i]);
            if (target && target.standaloneVariantId) {
              const dup = cart.items.find((it) => Number(it.variant_id) === target.standaloneVariantId);
              if (dup) {
                await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  body: JSON.stringify({ id: String(dup.variant_id), quantity: 0 })
                });
                return refreshCart();
              }
            }
          }
        }
      }

      document.querySelectorAll('[data-cart-count]').forEach((node) => node.textContent = cart.item_count);
      const body = document.querySelector('[data-cart-body]');
      const foot = document.querySelector('[data-cart-foot]');
      if (!body || !foot) return;
      if (!cart.items.length) {
        body.innerHTML = '<div class="hd-cart-empty"><span class="hd-cart-empty__icon">🛍️</span><p>Sepetiniz şu anda boş.</p><button type="button" class="hd-cart-empty__btn" data-cart-close>Alışverişe Başla</button></div>';
        body.querySelector('[data-cart-close]')?.addEventListener('click', closeCart);
        foot.hidden = true;
        return;
      }
      body.innerHTML = cart.items.map((item, index) => {
        const isGift = Boolean(item.properties && (item.properties._bundle_gift === 'true' || item.properties['Hediye'] || item.properties['_bundle_gift']));
        const props = Object.entries(item.properties || {})
          .filter(([k, v]) => v && !k.startsWith('_'))
          .map(([k, v]) => `<small class="hd-cart-prop"><b>${k}:</b> ${String(v).startsWith('/uploads/') ? 'Yüklendi' : v}</small>`)
          .join('');
        const actionsHtml = isGift
          ? `<span class="hd-cart-gift-badge" style="background:#fef2f2;color:#dc2626;font-size:11px;font-weight:700;padding:3px 8px;border-radius:4px;border:1px solid #fecaca;display:inline-block;">🎁 Paket Hediyesi (1 Adet)</span>
             <button type="button" class="hd-cart-remove" data-remove-line="${index + 1}" style="margin-left:8px;">Kaldır</button>`
          : `<div class="hd-cart-qty">
              <button type="button" data-qty-change="-1" data-line="${index + 1}" data-qty="${item.quantity}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-qty-change="1" data-line="${index + 1}" data-qty="${item.quantity}">+</button>
            </div>
            <button type="button" class="hd-cart-remove" data-remove-line="${index + 1}">Kaldır</button>`;
        const priceHtml = isGift
          ? `<strong class="hd-cart-item__price" style="color:#16a34a;"><del style="color:#9ca3af;font-size:11.5px;margin-right:4px;font-weight:500;">${money(item.final_line_price)}</del> ÜCRETSİZ</strong>`
          : `<strong class="hd-cart-item__price">${money(item.final_line_price)}</strong>`;
        return `<article class="hd-cart-item" data-line="${index + 1}">
          <div class="hd-cart-item__media">
            ${item.image ? `<img src="${item.image}" alt="${item.product_title}" class="hd-cart-item__img">` : ''}
          </div>
          <div class="hd-cart-item__info">
            <b>${item.product_title}</b>
            ${item.variant_title ? `<small class="hd-cart-item__variant">${item.variant_title}</small>` : ''}
            ${props}
            <div class="hd-cart-item__actions">
              ${actionsHtml}
            </div>
          </div>
          ${priceHtml}
        </article>`;
      }).join('');
      foot.hidden = false;
      const totalNode = document.querySelector('[data-cart-total]');
      if (totalNode) totalNode.textContent = money(cart.total_price);

      body.querySelectorAll('[data-remove-line]').forEach((button) => button.addEventListener('click', async () => {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ line: Number(button.dataset.removeLine), quantity: 0 }) });
        await refreshCart();
      }));

      body.querySelectorAll('[data-qty-change]').forEach((button) => button.addEventListener('click', async () => {
        const line = Number(button.dataset.line);
        const newQty = Math.max(0, Number(button.dataset.qty) + Number(button.dataset.qtyChange));
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({ line, quantity: newQty }) });
        await refreshCart();
      }));
    } catch(err) {
      console.error('refreshCart error:', err);
    }
  }

  document.querySelectorAll('.hd-cart-drawer__checkout-btn, [data-cart-checkout-btn], a[href="/checkout"]').forEach((button) => {
    button.addEventListener('click', async (e) => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
        const c = await response.json();
        if (window.HD_UPSELL_GUARD) {
          const modified = await window.HD_UPSELL_GUARD.enforceCart(c);
          if (modified) {
            e.preventDefault();
            button.style.pointerEvents = 'none';
            button.textContent = 'Yönlendiriliyor…';
            window.location.href = `${window.Shopify?.routes?.root || '/'}checkout`;
            return;
          }
        }
      } catch (err) {}
    });
  });

  document.querySelectorAll('[data-upsell-quick-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variantId;
      btn.disabled = true;
      btn.textContent = 'Ekleniyor…';
      try {
        await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        });
        btn.textContent = '✓ Eklendi';
        await refreshCart();
      } catch (e) {
        btn.disabled = false;
        btn.textContent = '+ Ekle';
      }
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const form = root.querySelector('[data-product-form]');
    const variants = JSON.parse(root.querySelector('[data-product-json]')?.textContent || '[]');
    const variantInput = form?.querySelector('[data-variant-id]');
    const quantityInput = form?.querySelector('[data-quantity]');
    const addButton = form?.querySelector('[data-add-button]');
    let packageUpsells = form?.querySelector('[data-package-upsells]');
    let currentVariant = variants.find((variant) => String(variant.id) === variantInput?.value) || variants[0];
    let quantity = 1;

    const bundleTiers = () => [...root.querySelectorAll('.mpb-offer__tier-box, .bundle-card')];
    const bundleTierTitle = (tier) => tier?.querySelector('.bundle-card-title, .mpb-offer__tier-title, .mpb-offer__tier-box-title')?.textContent || tier?.textContent || '';
    const selectedBundleTier = () => bundleTiers().find((tier) =>
      tier.matches('.bundle-card--selected') ||
      Boolean(tier.querySelector('.bundle-radio-input:checked, .mpb-offer__radio-icon.checked'))
    );
    const oneItemBundleTier = () => bundleTiers().find((tier) => /(^|\s)1\s*adet/i.test(bundleTierTitle(tier))) || bundleTiers()[0];
    const selectedBundleQuantity = () => {
      const tier = selectedBundleTier();
      if (!tier) return 1;
      const match = bundleTierTitle(tier).match(/(^|\s)(\d+)\s*adet/i);
      if (match) return Math.max(1, Number(match[2]));
      return Math.max(1, tier.querySelectorAll('.mpb-variant-select').length || 1);
    };
    const selectedBundleVariantIds = () => {
      const tier = selectedBundleTier();
      if (!tier) return [];
      const scope = tier.closest('.card-wrapper') || tier;
      return [...scope.querySelectorAll('[data-aa-bundle-variant]')]
        .map((select) => Number(select.value))
        .filter((id) => Number.isFinite(id) && id > 0);
    };
    const isUpsellTierActive = () => {
      const targetTier = oneItemBundleTier();
      return !targetTier || selectedBundleTier() === targetTier;
    };
    const selectedUpsellItems = () => (isUpsellTierActive() ? [...packageUpsells?.querySelectorAll('[data-upsell-checkbox]:checked') || []] : [])
      .map((input) => {
        if (window.HD_UPSELL_GUARD && input.dataset.standaloneVariantId) {
          window.HD_UPSELL_GUARD.register(
            input.value,
            input.dataset.standaloneVariantId,
            input.dataset.standalonePrice,
            input.dataset.standaloneHandle,
            input.dataset.upsellHandle,
            input.dataset.standaloneTitle
          );
        }
        return {
          id: Number(input.value),
          quantity: 1,
          properties: {
            '_is_upsell': 'true',
            '_Ek ürün': 'Paket içi öneri',
            '_standalone_variant_id': input.dataset.standaloneVariantId || '',
            '_standalone_price': input.dataset.standalonePrice || '',
            '_standalone_handle': input.dataset.standaloneHandle || '',
            '_standalone_title': input.dataset.standaloneTitle || ''
          }
        };
      })
      .filter((item) => Number.isFinite(item.id) && item.id > 0);
    const selectedUpsellTotal = () => (isUpsellTierActive() ? [...packageUpsells?.querySelectorAll('[data-upsell-checkbox]:checked') || []] : [])
      .reduce((total, input) => total + Number(input.dataset.upsellPrice || 0), 0);

    const parseBundleMoney = (value = '') => {
      const cleaned = String(value).replace(/[^0-9,.-]/g, '');
      if (!cleaned) return null;
      const lastComma = cleaned.lastIndexOf(',');
      const lastDot = cleaned.lastIndexOf('.');
      const decimalIndex = Math.max(lastComma, lastDot);
      const decimalDigits = decimalIndex >= 0 ? cleaned.length - decimalIndex - 1 : 0;
      let normalized;
      if (decimalIndex >= 0 && decimalDigits === 2) {
        normalized = cleaned.slice(0, decimalIndex).replace(/[.,]/g, '') + '.' + cleaned.slice(decimalIndex + 1);
      } else {
        normalized = cleaned.replace(/[.,]/g, '');
      }
      const amount = Number(normalized);
      return Number.isFinite(amount) ? Math.round(amount * 100) : null;
    };
    const selectedBundleTotal = () => {
      const selectedTier = selectedBundleTier();
      return parseBundleMoney(selectedTier?.querySelector('.mpb-offer__price-current, .bundle-current-price')?.textContent || '');
    };
    const syncBundleButtonPrice = () => {
      root.classList.toggle('has-mpb-bundle', Boolean(root.querySelector('.mpb-offer, .orichi-bundle')));
      const bundleTotal = selectedBundleTotal();
      if (bundleTotal === null) return false;
      quantity = selectedBundleQuantity();
      if (quantityInput) quantityInput.value = quantity;
      const formatted = money(bundleTotal + selectedUpsellTotal());
      const buttonPrice = root.querySelector('[data-button-price]');
      if (buttonPrice && buttonPrice.textContent !== formatted) buttonPrice.textContent = formatted;
      document.querySelectorAll('[data-mobile-price]').forEach((node) => { if (node.textContent !== formatted) node.textContent = formatted; });
      document.querySelectorAll('[data-mobile-quantity-label]').forEach((node) => { node.textContent = `${quantity} adet · `; });
      const selectedTier = selectedBundleTier();
      const previousTotal = parseBundleMoney(selectedTier?.querySelector('.mpb-offer__price-previous, .bundle-original-price')?.textContent || '');
      document.querySelectorAll('[data-mobile-compare]').forEach((node) => {
        node.hidden = previousTotal === null || previousTotal <= bundleTotal;
        if (!node.hidden) node.textContent = money(previousTotal);
      });
      document.querySelectorAll('[data-mobile-discount]').forEach((node) => {
        const discount = previousTotal && previousTotal > bundleTotal ? Math.round((previousTotal - bundleTotal) * 100 / previousTotal) : 0;
        node.hidden = !discount;
        if (discount) node.textContent = `%${discount} indirim`;
      });
      return true;
    };

    const toMediaGroup = (value = '') => value
      .toLocaleLowerCase('tr-TR')
      .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    const previewForBundleOption = (label = '') => {
      const optionKey = toMediaGroup(label);
      const visualOption = [...root.querySelectorAll('.aa-visual-options .aa-option')]
        .find((button) => toMediaGroup(button.dataset.optionValue || button.textContent) === optionKey);
      const optionImage = visualOption?.querySelector('img');
      if (optionImage) return optionImage.currentSrc || optionImage.src;
      const matchingVariant = variants.find((variant) => (variant.options || []).some((value) => toMediaGroup(value) === optionKey));
      return matchingVariant?.featured_image?.src || root.querySelector('.aa-gallery__slide:not([hidden]) img')?.currentSrc || '';
    };

    const closeBundleVisualSelects = (except) => {
      root.querySelectorAll('.aa-mpb-visual-select.is-open').forEach((wrapper) => {
        if (wrapper !== except) {
          wrapper.classList.remove('is-open');
          wrapper.querySelector('.aa-mpb-visual-trigger')?.setAttribute('aria-expanded', 'false');
        }
      });
    };

    const mountPackageUpsells = () => {
      packageUpsells = root.querySelector('[data-package-upsells]') || form?.querySelector('[data-package-upsells]') || packageUpsells;
      if (!packageUpsells) return;
      const oneItemTier = oneItemBundleTier();
      const oneItemWrapper = oneItemTier?.closest('.card-wrapper');
      const destination = oneItemTier?.querySelector('.mpb-offer__tier-box-content') || oneItemTier || root.querySelector('.mpb-offer') || packageUpsells.parentElement;
      if (oneItemWrapper?.parentElement) {
        if (oneItemWrapper.nextElementSibling !== packageUpsells) oneItemWrapper.insertAdjacentElement('afterend', packageUpsells);
      } else if (destination && packageUpsells.parentElement !== destination) {
        destination.appendChild(packageUpsells);
      }
      packageUpsells.classList.toggle('is-mounted', Boolean(destination));
      packageUpsells.classList.add('is-active');
      packageUpsells.classList.toggle('is-tier-active', isUpsellTierActive());
      packageUpsells.setAttribute('aria-hidden', 'false');
    };

    const syncPackageUpsells = () => {
      packageUpsells?.querySelectorAll('[data-upsell-row]').forEach((row) => {
        row.classList.toggle('is-selected', Boolean(row.querySelector('[data-upsell-checkbox]')?.checked));
      });
    };

    const mountBundleVariantSelects = () => {
      if (root.dataset.productHandle !== 'spotify-makyaj-tablosu-dunya-nin-en-guzel-kizi-aynasi' || variants.length < 2) return;
      const availableVariants = variants.filter((variant) => variant.available !== false);
      if (!availableVariants.length) return;
      root.classList.add('has-aa-bundle-variant-picker');

      root.querySelectorAll('.bundle-card:not([data-aa-variant-picker])').forEach((card) => {
        const match = bundleTierTitle(card).match(/(^|\s)([123])\s*adet/i);
        const itemCount = match ? Number(match[2]) : 0;
        const content = card.querySelector('.bundle-content');
        if (!itemCount || !content) return;

        card.dataset.aaVariantPicker = 'true';
        const grid = document.createElement('div');
        grid.className = 'aa-bundle-variant-grid';
        grid.setAttribute('aria-label', String(itemCount) + ' ürün için renk seçimi');

        for (let itemIndex = 0; itemIndex < itemCount; itemIndex += 1) {
          const slot = document.createElement('div');
          slot.className = 'aa-bundle-variant-slot';
          const heading = document.createElement('div');
          heading.className = 'aa-bundle-variant-slot__heading';
          heading.innerHTML = '<strong>' + String(itemIndex + 1) + '. Ürün</strong><span>Rengini seçin</span>';

          const select = document.createElement('select');
          select.className = 'mpb-variant-select aa-bundle-variant-native';
          select.dataset.aaBundleVariant = '';
          select.setAttribute('aria-label', String(itemIndex + 1) + '. ürün rengi');

          availableVariants.forEach((variant) => {
            const option = document.createElement('option');
            option.value = String(variant.id);
            option.textContent = (variant.options || []).filter(Boolean).join(' / ') || variant.title;
            if (String(variant.id) === String(currentVariant?.id)) option.selected = true;
            select.appendChild(option);
          });

          slot.append(heading, select);
          grid.appendChild(slot);
        }

        const cardWrapper = card.closest('.card-wrapper');
        (cardWrapper || card).appendChild(grid);
      });
    };
    let bundleVisualIndex = 0;
    const enhanceBundleSelects = () => {
      root.querySelectorAll('.mpb-variant-select:not([data-aa-visualized])').forEach((select) => {
        if (!select.options?.length) return;
        select.dataset.aaVisualized = 'true';
        select.classList.add('aa-mpb-native-select');

        const wrapper = document.createElement('div');
        wrapper.className = 'aa-mpb-visual-select';
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'aa-mpb-visual-trigger';
        trigger.setAttribute('aria-expanded', 'false');
        const visualIndex = bundleVisualIndex++;
        trigger.setAttribute('aria-controls', `BundleVisualMenu-${root.dataset.sectionId}-${visualIndex}`);

        const triggerImage = document.createElement('img');
        triggerImage.alt = '';
        const triggerLabel = document.createElement('span');
        const triggerChevron = document.createElement('i');
        triggerChevron.textContent = '⌄';
        trigger.append(triggerImage, triggerLabel, triggerChevron);

        const menu = document.createElement('div');
        menu.className = 'aa-mpb-visual-menu';
        menu.id = `BundleVisualMenu-${root.dataset.sectionId}-${visualIndex}`;
        menu.setAttribute('role', 'listbox');

        const optionButtons = [...select.options].map((option) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'aa-mpb-visual-option';
          button.dataset.value = option.value;
          button.setAttribute('role', 'option');
          const image = document.createElement('img');
          image.src = previewForBundleOption(option.textContent.trim());
          image.alt = '';
          const label = document.createElement('span');
          label.textContent = option.textContent.trim();
          const check = document.createElement('b');
          button.append(image, label, check);
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            select.value = option.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            wrapper.classList.remove('is-open');
            trigger.setAttribute('aria-expanded', 'false');
            sync();
          });
          menu.append(button);
          return button;
        });

        const sync = () => {
          const selectedOption = select.options[select.selectedIndex] || select.options[0];
          if (!selectedOption) return;
          triggerLabel.textContent = selectedOption.textContent.trim();
          triggerImage.src = previewForBundleOption(selectedOption.textContent.trim());
          optionButtons.forEach((button) => {
            const active = String(button.dataset.value) === String(selectedOption.value);
            button.classList.toggle('is-selected', active);
            button.setAttribute('aria-selected', active ? 'true' : 'false');
            button.querySelector('b').textContent = active ? '✓' : '';
          });
        };

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const willOpen = !wrapper.classList.contains('is-open');
          closeBundleVisualSelects(wrapper);
          wrapper.classList.toggle('is-open', willOpen);
          trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        });
        select.addEventListener('change', sync);
        wrapper.append(trigger, menu);
        select.insertAdjacentElement('afterend', wrapper);
        sync();
      });
    };

    mountBundleVariantSelects();
    enhanceBundleSelects();
    mountPackageUpsells();
    syncPackageUpsells();
    if (root) {
      let enhanceFrame;
      const enhanceTarget = root.querySelector('.bundles-container, .aa-bundle-app, .orichi-bundle-spotlight, .aa-package-upsells') || root;
      new MutationObserver(() => {
        cancelAnimationFrame(enhanceFrame);
        enhanceFrame = requestAnimationFrame(() => {
          mountBundleVariantSelects();
          enhanceBundleSelects();
          mountPackageUpsells();
        });
      }).observe(enhanceTarget, { childList: true, subtree: true });
    }
    if (!root.dataset.aaBundleVisualCapture) {
      root.dataset.aaBundleVisualCapture = 'true';
      window.addEventListener('click', (event) => {
        if (!root.contains(event.target)) return;
        const trigger = event.target.closest('.aa-mpb-visual-trigger');
        const option = event.target.closest('.aa-mpb-visual-option');
        if (!trigger && !option) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const wrapper = (trigger || option).closest('.aa-mpb-visual-select');
        if (!wrapper) return;
        const wrapperTrigger = wrapper.querySelector('.aa-mpb-visual-trigger');
        if (trigger) {
          const willOpen = !wrapper.classList.contains('is-open');
          closeBundleVisualSelects(wrapper);
          wrapper.classList.toggle('is-open', willOpen);
          wrapperTrigger?.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          return;
        }
        const select = wrapper.previousElementSibling;
        if (!select?.matches('[data-aa-bundle-variant]')) return;
        select.value = option.dataset.value || select.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        wrapper.classList.remove('is-open');
        wrapperTrigger?.setAttribute('aria-expanded', 'false');
      }, true);
    }

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.aa-mpb-visual-select')) closeBundleVisualSelects();
    });

    const selectMedia = (id) => {
      const target = root.querySelector(`[data-media-id="${id}"]:not([hidden])`);
      if (!target) return;
      root.querySelectorAll('[data-media-id]').forEach((slide) => {
        const active = slide === target;
        slide.classList.toggle('is-active', active);
        slide.querySelectorAll('video').forEach((video) => {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          if (active) video.play().catch(() => {});
          else video.pause();
        });
      });
      root.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.toggle('is-active', String(thumb.dataset.mediaTarget) === String(id)));
      const mobileImage = document.querySelector('[data-mobile-product-image]');
      const selectedImage = target.querySelector('img');
      if (mobileImage && selectedImage) {
        mobileImage.src = selectedImage.currentSrc || selectedImage.src;
        mobileImage.srcset = selectedImage.srcset || '';
      }
    };
    const filterVariantMedia = (preferredMediaId) => {
      const slides = [...root.querySelectorAll('[data-media-id]')];
      const thumbs = [...root.querySelectorAll('[data-media-target]')];
      const mode = root.dataset.variantGalleryMode || 'order';
      if (mode === 'disabled') {
        slides.forEach((slide) => { slide.hidden = false; });
        thumbs.forEach((thumb) => { thumb.hidden = false; });
        if (preferredMediaId) selectMedia(preferredMediaId);
        return;
      }
      const galleryFieldset = root.querySelector('[data-gallery-option]') || root.querySelector('[data-option-index]');
      const selectedButton = galleryFieldset?.querySelector('.aa-option.is-selected');
      const selectedValue = selectedButton?.dataset.optionValue || '';
      const group = toMediaGroup(selectedValue);
      const optionPosition = selectedButton?.dataset.optionPosition || '0';
      const optionCount = galleryFieldset?.querySelectorAll('.aa-option').length || 0;
      const useOrder = mode === 'order';
      const hasTaggedMedia = useOrder || slides.some((slide) => slide.dataset.mediaGroup);
      const hasMatch = useOrder
        ? slides.some((slide) => slide.dataset.mediaOrderGroup === optionPosition)
        : slides.some((slide) => slide.dataset.mediaGroup === group);
      slides.forEach((slide) => {
        const commonMedia = slide.dataset.mediaCommon === 'true' || (useOrder && Number(slide.dataset.mediaOrderGroup) >= optionCount);
        slide.hidden = hasTaggedMedia && hasMatch && !commonMedia && (useOrder ? slide.dataset.mediaOrderGroup !== optionPosition : Boolean(slide.dataset.mediaGroup) && slide.dataset.mediaGroup !== group);
      });
      thumbs.forEach((thumb) => {
        const commonMedia = thumb.dataset.mediaCommon === 'true' || (useOrder && Number(thumb.dataset.mediaOrderGroup) >= optionCount);
        thumb.hidden = hasTaggedMedia && hasMatch && !commonMedia && (useOrder ? thumb.dataset.mediaOrderGroup !== optionPosition : Boolean(thumb.dataset.mediaGroup) && thumb.dataset.mediaGroup !== group);
      });
      const preferred = preferredMediaId && root.querySelector(`[data-media-id="${preferredMediaId}"]:not([hidden])`);
      const firstMatch = slides.find((slide) => !slide.hidden && (useOrder ? slide.dataset.mediaOrderGroup === optionPosition : slide.dataset.mediaGroup === group));
      const firstVisible = slides.find((slide) => !slide.hidden);
      selectMedia((preferred || firstMatch || firstVisible)?.dataset.mediaId);
    };

    const updatePrice = () => {
      const total = ((currentVariant?.price || 0) * quantity) + selectedUpsellTotal();
      root.querySelector('[data-price] strong').textContent = money(currentVariant?.price || 0);
      const regularTotal = money(total);
      root.querySelector('[data-button-price]').textContent = regularTotal;
      document.querySelectorAll('[data-mobile-price]').forEach((node) => node.textContent = regularTotal);
      syncBundleButtonPrice();
      if (variantInput) variantInput.value = currentVariant?.id || '';
      if (quantityInput) quantityInput.value = quantity;
      if (addButton) { addButton.disabled = !currentVariant?.available; addButton.querySelector('[data-add-text]').textContent = currentVariant?.available ? 'Sepete ekle' : 'Tükendi'; }
      const matchingMedia = currentVariant?.featured_media?.id || currentVariant?.featured_image?.id;
      filterVariantMedia(matchingMedia);
    };
    const selectedOptions = () => [...root.querySelectorAll('[data-option-index]')].map((fieldset) => fieldset.querySelector('.aa-option.is-selected')?.dataset.optionValue);

    root.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => {
      const fieldset = button.closest('[data-option-index]');
      fieldset.querySelectorAll('[data-option-value]').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed','false'); });
      button.classList.add('is-selected'); button.setAttribute('aria-pressed','true');
      fieldset.querySelector('[data-selected-option]').textContent = button.dataset.optionValue;
      if (root.querySelector('.mpb-offer')) {
        filterVariantMedia();
        return;
      }
      const options = selectedOptions();
      currentVariant = variants.find((variant) => variant.options.every((value, index) => value === options[index])) || currentVariant;
      updatePrice();
      if (currentVariant?.id) history.replaceState({}, '', `${location.pathname}?variant=${currentVariant.id}`);
    }));
    root.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => selectMedia(button.dataset.mediaTarget)));

    const galleryMain = root.querySelector('.aa-gallery__main');
    if (galleryMain) {
      let swipeStartX = 0;
      let swipeStartY = 0;
      let swipePointerId = null;

      const visibleGallerySlides = () => [...root.querySelectorAll('[data-media-id]')].filter((slide) => !slide.hidden);
      const moveGallery = (direction) => {
        const slides = visibleGallerySlides();
        if (slides.length < 2) return;
        const activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
        const nextIndex = (activeIndex + direction + slides.length) % slides.length;
        selectMedia(slides[nextIndex].dataset.mediaId);
      };

      galleryMain.addEventListener('dragstart', (event) => event.preventDefault());
      galleryMain.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        swipePointerId = event.pointerId;
        swipeStartX = event.clientX;
        swipeStartY = event.clientY;
        galleryMain.classList.add('is-dragging');
        galleryMain.setPointerCapture?.(event.pointerId);
      });
      galleryMain.addEventListener('pointerup', (event) => {
        if (swipePointerId !== event.pointerId) return;
        const deltaX = event.clientX - swipeStartX;
        const deltaY = event.clientY - swipeStartY;
        galleryMain.classList.remove('is-dragging');
        galleryMain.releasePointerCapture?.(event.pointerId);
        swipePointerId = null;
        if (Math.abs(deltaX) >= 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15) moveGallery(deltaX < 0 ? 1 : -1);
      });
      galleryMain.addEventListener('pointercancel', () => {
        galleryMain.classList.remove('is-dragging');
        swipePointerId = null;
      });

      const keepActiveVideoPlaying = () => {
        const video = galleryMain.querySelector('.aa-gallery__slide.is-active video');
        if (!video) return;
        video.controls = false;
        video.removeAttribute('controls');
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        if (video.paused) video.play().catch(() => {});
      };
      galleryMain.querySelectorAll('video').forEach((video) => {
        video.controls = false;
        video.removeAttribute('controls');
        video.muted = true;
        video.defaultMuted = true;
        video.loop = true;
        video.autoplay = true;
        video.playsInline = true;
        video.addEventListener('pause', () => {
          if (video.closest('.aa-gallery__slide')?.classList.contains('is-active')) video.play().catch(() => {});
        });
      });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) keepActiveVideoPlaying(); });
      window.addEventListener('focus', keepActiveVideoPlaying);
      keepActiveVideoPlaying();
    }
    root.querySelectorAll('[data-offer-quantity]').forEach((button) => button.addEventListener('click', () => { root.querySelectorAll('[data-offer-quantity]').forEach((item) => item.classList.remove('is-selected')); button.classList.add('is-selected'); quantity = Number(button.dataset.offerQuantity); updatePrice(); }));
    packageUpsells?.addEventListener('change', (event) => {
      if (!event.target.matches('[data-upsell-checkbox]')) return;
      syncPackageUpsells();
      updatePrice();
    });
    const fileInput = root.querySelector('[data-file-input]');
    fileInput?.addEventListener('change', () => { const label = root.querySelector('[data-file-label]'); if (label) label.textContent = fileInput.files?.[0]?.name || 'JPG veya PNG seçin'; });
    const codButton = root.querySelector('[data-cod-button]');
    codButton?.addEventListener('click', async (event) => {
      if (window.HDNativeCOD && typeof window.HDNativeCOD.open === 'function') {
        event?.preventDefault();
        event?.stopPropagation();
        window.HDNativeCOD.open();
        return;
      }
      if (codButton.dataset.preparing === 'true') return;
      if (!form.reportValidity()) return;
      const feeVariantId = Number(codButton.dataset.codFeeVariant || 0);
      codButton.dataset.preparing = 'true';
      codButton.classList.add('is-loading');
      codButton.disabled = true;
      if (addButton) addButton.disabled = true;

      try {
        mountPackageUpsells();
        syncPackageUpsells();

        const bundleVariantIds = selectedBundleVariantIds();
        const fallbackVariantId = Number(currentVariant?.id || variantInput?.value || 0);
        const fallbackQuantity = Math.max(1, Number(quantityInput?.value || quantity || 1));
        const mainVariantIds = bundleVariantIds.length
          ? bundleVariantIds
          : Array.from({ length: fallbackQuantity }, () => fallbackVariantId).filter(Boolean);

        if (!mainVariantIds.length) throw new Error('Seçilen ürün varyasyonu bulunamadı.');

        const quantitiesByVariant = mainVariantIds.reduce((map, id) => {
          map.set(id, (map.get(id) || 0) + 1);
          return map;
        }, new Map());

        const mainItems = [...quantitiesByVariant].map(([id, itemQuantity]) => ({
          id,
          quantity: itemQuantity,
          properties: { 'Ödeme tercihi': 'Kapıda ödeme' }
        }));
        const upsellItems = selectedUpsellItems();

        let feeAlreadyAdded = true;
        if (feeVariantId) {
          const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
            headers: { Accept: 'application/json' }
          });
          if (!cartResponse.ok) throw new Error('Sepet bilgisi alınamadı.');
          const cart = await cartResponse.json();
          feeAlreadyAdded = cart.items.some((item) => Number(item.variant_id) === feeVariantId);
        }

        const codItems = [
          ...mainItems,
          ...upsellItems,
          ...(feeVariantId && !feeAlreadyAdded ? [{
            id: feeVariantId,
            quantity: 1,
            properties: { '_Hizmet türü': 'Kapıda ödeme' }
          }] : [])
        ];

        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: codItems })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Kapıda ödeme sepeti hazırlanamadı.');
        }

        await response.json();
        window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
      } catch (error) {
        window.alert(error?.message || 'Kapıda ödeme hazırlanamadı. Lütfen tekrar deneyin.');
        codButton.dataset.preparing = 'false';
        codButton.classList.remove('is-loading');
        codButton.disabled = false;
        if (addButton) addButton.disabled = !currentVariant?.available;
      }
    });
    form?.addEventListener('submit', async (event) => {
      if (!form.reportValidity()) return;
      event.preventDefault();
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      addButton.disabled = true;
      addButton.querySelector('[data-add-text]').textContent = 'Sepete ekleniyor…';
      try {
        const bundleVariantIds = selectedBundleVariantIds();
        let response;
        if (bundleVariantIds.length) {
          const quantitiesByVariant = bundleVariantIds.reduce((map, id) => map.set(id, (map.get(id) || 0) + 1), new Map());
          const items = [...quantitiesByVariant].map(([id, itemQuantity]) => ({ id, quantity: itemQuantity }));
          response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
        } else {
          response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
        }
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Ürün sepete eklenemedi.');
        }
        await response.json();
        const upsellItems = selectedUpsellItems();
        if (upsellItems.length) {
          const upsellResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: upsellItems })
          });
          if (!upsellResponse.ok) {
            const upsellError = await upsellResponse.json().catch(() => ({}));
            throw new Error(upsellError.description || upsellError.message || 'Ana ürün sepete eklendi ancak ek ürün eklenemedi.');
          }
        }

        // Add 3 Adet Free Gift to Cart
        const bundleCard = root.querySelector('.bundle-card.bundle-card--selected, .mpb-offer__tier-box--selected');
        const activeTier = bundleCard?.dataset.tier || (quantityInput?.value) || '1';
        const bundleRoot = root.querySelector('[data-native-bundle-root]');
        if (String(activeTier) === '3') {
          const giftVariantId = bundleRoot?.dataset.giftVariantId || '48396151488748';
          try {
            await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: Number(giftVariantId),
                  quantity: 1,
                  properties: {
                    '_bundle_gift': 'true',
                    'Hediye': '3 Adet Paket Hediyesi (Ücretsiz)'
                  }
                }]
              })
            });
          } catch(giftErr) {
            console.warn('Gift add error:', giftErr);
          }
        }
        if (form.dataset.codCheckout === 'true') {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}checkout`);
        } else if (drawer) {
          await refreshCart();
          openCart();
        } else {
          window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        }
      } catch (error) {
        window.alert(error?.message || 'Ürün sepete eklenemedi. Lütfen tekrar deneyin.');
      } finally {
        form.dataset.submitting = 'false';
        addButton.disabled = !currentVariant?.available;
        addButton.querySelector('[data-add-text]').textContent = currentVariant?.available ? 'Sepete ekle' : 'Tükendi';
        if (codButton) { codButton.dataset.preparing = 'false'; codButton.classList.remove('is-loading'); codButton.disabled = false; }
        delete form.dataset.codCheckout;
        syncBundleButtonPrice();
      }
    });
    if (!root.dataset.aaOrichiCodBridge) {
      root.dataset.aaOrichiCodBridge = 'true';
      window.addEventListener('click', (event) => {
        if (!event.isTrusted) return;
        const orichiButton = event.target.closest('.orichi-cod-button');
        if (!orichiButton) return;

        mountPackageUpsells();
        syncPackageUpsells();
        const bundleVariantIds = selectedBundleVariantIds();
        const upsellItems = selectedUpsellItems();
        if (!bundleVariantIds.length && !upsellItems.length) return;

        const originalFetch = window.fetch;
        let restored = false;
        const restoreFetch = () => {
          if (restored) return;
          restored = true;
          window.fetch = originalFetch;
        };

        window.fetch = async function(resource, options = {}) {
          const requestUrl = typeof resource === 'string' ? resource : resource?.url || '';
          if (/\/cart\/update\.js(?:\?|$)/.test(requestUrl) && options?.body) {
            try {
              const requestBody = JSON.parse(options.body);
              const updates = bundleVariantIds.length ? {} : { ...(requestBody.updates || {}) };
              bundleVariantIds.forEach((id) => {
                updates[id] = (updates[id] || 0) + 1;
              });
              upsellItems.forEach((item) => {
                updates[item.id] = item.quantity || 1;
              });
              options = { ...options, body: JSON.stringify({ ...requestBody, updates }) };
            } catch (_) {}
            restoreFetch();
          }
          return originalFetch.call(this, resource, options);
        };

        window.setTimeout(restoreFetch, 10000);
      }, true);
    }

    document.querySelectorAll('[data-mobile-add]').forEach((button) => button.addEventListener('click', () => form?.requestSubmit()));
    updatePrice();

    if (root) {
      const scheduleBundlePriceSync = () => requestAnimationFrame(() => {
        mountPackageUpsells();
        syncBundleButtonPrice();
      });
      root.addEventListener('click', (event) => { if (event.target.closest('.mpb-offer, .bundle-card')) scheduleBundlePriceSync(); }, { passive: true });
      root.addEventListener('change', (event) => { if (event.target.closest('.mpb-offer, .bundle-card')) scheduleBundlePriceSync(); }, { passive: true });
      const bundleTarget = root.querySelector('.bundles-container, .aa-bundle-app, .orichi-bundle-spotlight, .aa-package-upsells') || root;
      new MutationObserver(scheduleBundlePriceSync).observe(bundleTarget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  });

  document.querySelectorAll('[data-recent-buyers]').forEach((number) => {
    const update = () => { number.textContent = randomBetween(Number(number.dataset.min || 5), Number(number.dataset.max || 14)); };
    update(); setInterval(update, 8300);
  });

  document.querySelectorAll('[data-story-section]').forEach((section) => {
    const modal = section.querySelector('[data-story-modal]');
    const sources = [...section.querySelectorAll('[data-story-source]')];
    const current = section.querySelector('[data-story-current-media]');
    const preview = section.querySelector('[data-story-preview-media]');
    const progress = section.querySelector('[data-story-progress]');
    const pauseButton = section.querySelector('[data-story-pause]');
    const muteButton = section.querySelector('[data-story-mute]');
    const pauseIcon = section.querySelector('[data-story-pause-icon]');
    const muteIcon = section.querySelector('[data-story-mute-icon]');
    let index = 0;
    let activeVideo = null;
    let imageTimer = null;

    const stopMedia = () => {
      clearTimeout(imageTimer);
      current?.querySelectorAll('video').forEach((video) => video.pause());
      preview?.querySelectorAll('video').forEach((video) => video.pause());
    };
    const close = () => {
      stopMedia();
      if (modal) modal.hidden = true;
      document.body.classList.remove('story-open');
    };
    const render = (nextIndex) => {
      if (!sources.length || !current || !preview) return;
      stopMedia();
      index = (nextIndex + sources.length) % sources.length;
      const source = sources[index];
      const nextSource = sources[(index + 1) % sources.length];
      current.replaceChildren(source.firstElementChild.cloneNode(true));
      preview.replaceChildren(nextSource.firstElementChild.cloneNode(true));
      section.querySelector('[data-story-name]').textContent = source.dataset.name || '';
      section.querySelector('[data-story-preview-name]').textContent = nextSource.dataset.name || '';
      const avatar = section.querySelector('[data-story-avatar]');
      const previewAvatar = section.querySelector('[data-story-preview-avatar]');
      avatar.src = source.dataset.avatar || '';
      previewAvatar.src = nextSource.dataset.avatar || '';
      avatar.hidden = !source.dataset.avatar;
      previewAvatar.hidden = !nextSource.dataset.avatar;
      progress.style.transition = 'none'; progress.style.width = '0%';
      activeVideo = current.querySelector('video');
      if (pauseIcon) pauseIcon.src = pauseIcon.dataset.pauseSrc;
      if (activeVideo) {
        activeVideo.muted = true; activeVideo.playsInline = true;
        if (muteIcon) muteIcon.src = muteIcon.dataset.mutedSrc;
        activeVideo.addEventListener('loadedmetadata', () => { progress.style.width = '0%'; });
        activeVideo.addEventListener('timeupdate', () => { progress.style.width = `${activeVideo.duration ? (activeVideo.currentTime / activeVideo.duration) * 100 : 0}%`; });
        activeVideo.addEventListener('ended', () => render(index + 1));
        activeVideo.play().catch(() => {});
      } else {
        requestAnimationFrame(() => { progress.style.transition = 'width 5s linear'; progress.style.width = '100%'; });
        imageTimer = setTimeout(() => render(index + 1), 5000);
      }
      const previewVideo = preview.querySelector('video');
      if (previewVideo) { previewVideo.muted = true; previewVideo.loop = true; previewVideo.playsInline = true; previewVideo.play().catch(() => {}); }
    };
    const open = (startIndex) => {
      if (!modal || !sources.length) return;
      modal.hidden = false; document.body.classList.add('story-open'); render(startIndex);
    };

    section.querySelectorAll('[data-story-open]').forEach((button) => button.addEventListener('click', () => open(Number(button.dataset.storyOpen))));
    section.querySelector('[data-story-close]')?.addEventListener('click', close);
    section.querySelector('[data-story-prev]')?.addEventListener('click', () => render(index - 1));
    section.querySelector('[data-story-next]')?.addEventListener('click', () => render(index + 1));
    section.querySelector('[data-story-preview]')?.addEventListener('click', () => render(index + 1));
    modal?.addEventListener('click', (event) => { if (event.target === modal) close(); });
    pauseButton?.addEventListener('click', () => {
      if (!activeVideo) return;
      if (activeVideo.paused) { activeVideo.play().catch(() => {}); pauseIcon.src = pauseIcon.dataset.pauseSrc; }
      else { activeVideo.pause(); pauseIcon.src = pauseIcon.dataset.playSrc; }
    });
    muteButton?.addEventListener('click', () => {
      if (!activeVideo) return;
      activeVideo.muted = !activeVideo.muted;
      muteIcon.src = activeVideo.muted ? muteIcon.dataset.mutedSrc : muteIcon.dataset.soundSrc;
      muteButton.setAttribute('aria-label', activeVideo.muted ? 'Sesi aç' : 'Sesi kapat');
    });
    document.addEventListener('keydown', (event) => {
      if (modal?.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowRight') render(index + 1);
      if (event.key === 'ArrowLeft') render(index - 1);
    });
  });

  // --- SMART VIDEO AUTOPLAY & RESOURCE SAVER (Eliminates mobile lag and stutter) ---
  if ('IntersectionObserver' in window) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (video.closest('[data-story-modal]')) return;

        if (entry.isIntersecting) {
          if (video.paused && !video.dataset.userPaused) {
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(() => {});
            }
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, { threshold: 0.15 });

    function initVideoObserver() {
      document.querySelectorAll('video').forEach((v) => {
        if (v.closest('[data-story-modal]')) return;
        v.muted = true;
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
        videoObserver.observe(v);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVideoObserver, { once: true });
    } else {
      initVideoObserver();
    }
    setTimeout(initVideoObserver, 1000);
  }
})();
